<template>
	<el-drawer title="分享商品" :visible.sync="drawer" :direction="direction" size="400px" :before-close="handleClose">
		<div class="drawer-box" v-loading="loading">
			<div :class="['tips', state === '1' ? 'defalut' : 'warning']" v-if="$isDy(platformId)">
				<p class="flex flex-align-center">
					<i :class="['el-icon-warning', state === '1' ? 'primary' : 'warn']"></i>
					<span class="fz-14 ml-8">{{ content }}</span>
				</p>
			</div>
			<div class="recommend fz-14 mt-16 mb-16">
				<el-checkbox v-model="recommendInfoChecked">推荐人信息</el-checkbox>
				<el-checkbox v-if="$isPlatOr(platformId, ['Dy', 'Ks'])" v-model="shopScoreChecked">店铺评分</el-checkbox>
			</div>
			<div class="content" ref="content">
				<div class="top flex">
					<div class="avatar">
						<el-avatar :size="38" shape="square" icon="el-icon-user-solid"></el-avatar>
					</div>
					<div class="top-img ml-12" ref="img">
						<div class="defalut-img" v-if="imgLoad">
							<i class="el-icon-loading img-loading"></i>
						</div>
						<img v-else :src="product_pic" alt="" />
						<el-tooltip class="item" effect="dark" content="复制" placement="top">
							<div class="copy-box" @click="copy('img')" v-if="!imgLoad && issuccessWebpConvert">
								<i class="el-icon-document-copy"></i>
							</div>
						</el-tooltip>
					</div>
				</div>
				<div class="middle flex mt-24">
					<div class="avatar">
						<el-avatar :size="38" shape="square" icon="el-icon-user-solid"></el-avatar>
					</div>
					<div class="chat-box ml-12" ref="chat">
						<el-tooltip class="item" effect="dark" content="点击鼠标编辑" placement="top">
							<div contenteditable="true" class="chat fz-14 yx-color-text-primary">
								<p>{{ product_name }}</p>
								<p class="mt-20">
									<span>直播价：</span>
									<span>{{ live_price || '-' }}元</span>
								</p>
								<p class="mt-6">
									<span>佣金率：</span>
									<span>{{ commission_rate || '-' }}%</span>
								</p>
								<p class="mt-6" v-if="$isDy(platformId) && commission_rate_during_the && commission_rate_during_the!= 0">
									<span>投放期佣金率：</span>
									<span>{{ commission_rate_during_the || '-' }}%</span>
								</p>
								<p class="mt-6">
									<span>规格：</span>
									<span>{{ spec || '-' }}</span>
								</p>
								<div class="mt-6" v-if="shopScoreChecked">
									<p>店铺评分：</p>
									<p>商家体验分 {{ shop_scores.shop_score || '-' }}</p>
									<p v-if="$isDy(platformId)">商品体验 {{ shop_scores.product_score || '-' }}</p>
									<p v-if="$isDy(platformId)">物流体验 {{ shop_scores.logistics_score || '-' }}</p>
									<p v-if="$isDy(platformId)">商家服务 {{ shop_scores.service_score || '-' }}</p>
								</div>
								<p class="mt-20">
									<span>卖点：</span>
									<span v-html="selling_points || '-'"></span>
								</p>
								<p class="mt-20" v-if="$isPlatOr(platformId, ['Ks', 'Sp'])">
									<span>商品ID：</span>
									<span>{{ third_product_id || '-' }}</span>
								</p>
								<p class="mt-20" v-if="product_url">商品链接</p>
								<p class="mt-6" contenteditable="false" v-if="product_url">
									<a :href="product_url" class="pointer yx-color-primary" target="_blank">{{ product_url }}</a>
								</p>
							</div>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="复制" placement="top">
							<div class="copy-box" @click="copy('chat')">
								<i class="el-icon-document-copy"></i>
							</div>
						</el-tooltip>
					</div>
				</div>
				<div class="bottom flex mt-24 fz-14 yx-color-text-primary" v-if="recommendInfoChecked">
					<div class="avatar">
						<el-avatar :size="38" shape="square" icon="el-icon-user-solid"></el-avatar>
					</div>
					<div class="info-box ml-12">
						<el-tooltip class="item" effect="dark" content="点击鼠标编辑" placement="top">
							<div class="info" ref="info" contenteditable="true">
								<p>
									<span>推荐人：</span>
									<span>{{ vuex_userInfo.team_name || '-' }}-{{ vuex_userInfo.partner_role_name || '-' }}</span>
								</p>
								<p class="mt-6">
									<span>电话：</span>
									<span>{{ vuex_userInfo.mobile || '-' }}</span>
								</p>
								<p class="mt-6">
									<span>微信：</span>
									<span>{{ vuex_userInfo.wechat_account || '-' }}</span>
								</p>
							</div>
						</el-tooltip>
						<el-tooltip class="item" effect="dark" content="复制" placement="top">
							<div class="copy-box" @click="copy('info')">
								<i class="el-icon-document-copy"></i>
							</div>
						</el-tooltip>
					</div>
				</div>
			</div>
		</div>
		<div class="demo-drawer__footer footer mt-20">
			<el-button :loading="loading" type="primary" @click="copyAll">一键复制</el-button>
		</div>
	</el-drawer>
</template>
<script>
import { clipboard } from '@/utils/common';
import { getSourceUrl, getProductSkuListOne, syncProductSkuList, convertImgApi } from '@/api/shopManage';
import { mapState } from 'vuex';
export default {
	naem: 'shareDrawer',
	data() {
		return {
			drawer: false,
			direction: 'rtl',
			recommendInfoChecked: false,
			shopScoreChecked: false,
			content: '',
			state: '1',
			product_name: '',
			live_price: '',
			commission_rate: '',
			commission_rate_during_the: '',
			spec: '',
			selling_points: '',
			product_url: '',
			product_pic: '',
			third_product_id: '',
			product_id: '',
			platformId: '',
			shop_scores: {},
			issuccessWebpConvert: true,
			imgLoad: false,
			loading: false,
		};
	},
	computed: {
		...mapState(['vuex_userInfo']),
	},
	methods: {
		async convertImg({ product_pic, product_id }) {
			this.imgLoad = false;
			this.issuccessWebpConvert = true;
			let isSupported = await this.isWebPByMimeType(product_pic);
			if (isSupported) {
				this.imgLoad = true;
				//是webp格式的图片
				try {
					let res = await convertImgApi({ productId: product_id, imageUrl: product_pic });
					this.imgLoad = false;
					if (!res?.data?.imageUrl) {
						this.issuccessWebpConvert = false;
					}
					return res?.data?.imageUrl || product_pic;
				} catch (e) {
					this.imgLoad = false;
					this.issuccessWebpConvert = false;
					return product_pic;
				}
			} else {
				return product_pic;
			}
		},
		//判断是否是webp格式的图片
		async isWebPByMimeType(url) {
			return new Promise(async (resolve, reject) => {
				try {
					let flag = false;
					//请求并获取完整内容
					const response = await fetch(url);
					const contentType = response.headers.get('Content-Type');
					if (contentType == 'application/octet-stream') {
						// 如果是二进制流
						const buffer = await response.arrayBuffer();
						// 转换成 Uint8Array 以便读取字节
						const arr = new Uint8Array(buffer);
						// WebP 格式的文件头标识:
						// 1. 前4字节为 "RIFF" (52 49 46 46)
						// 2. 第8-11字节为 "WEBP" (57 45 42 50)
						if (arr.length < 12) {
							flag = false;
						} else {
							flag =
								arr[0] === 0x52 && // R
								arr[1] === 0x49 && // I
								arr[2] === 0x46 && // F
								arr[3] === 0x46 && // F
								arr[8] === 0x57 && // W
								arr[9] === 0x45 && // E
								arr[10] === 0x42 && // B
								arr[11] === 0x50; // P
						}
					} else {
						flag = contentType === 'image/webp' || contentType === 'image/avif';
					}
					resolve(flag);
				} catch (error) {
					resolve(false);
				}
			});
		},

		async show({
			product_name,
			live_price,
			commission_rate,
			commission_rate_during_the,
			spec,
			selling_points = '',
			product_url,
			product_pic,
			product_id,
			cooperate_id,
			source_type,
			third_product_id,
			platform_id,
			shop_scores,
		}) {
			this.loading = true;
			try {
				this.drawer = true;
				this.product_name = product_name;
				this.live_price = live_price;
				this.third_product_id = third_product_id;
				this.product_id = product_id;
				this.commission_rate = commission_rate;
				this.commission_rate_during_the = commission_rate_during_the;
				this.shop_scores = shop_scores;
				this.spec = spec;
				this.platformId = platform_id;
				this.selling_points = selling_points.replace(/\n/g, '<br/>');

				product_pic = await this.convertImg({ product_pic: product_pic, product_id: product_id });
				this.product_pic = product_pic.replace('https', 'http');
				await this.asyncSkuList();
				await this.getSkuList();
				if (this.$isDy(this.platformId)) {
					await this.dyInit({ product_id, cooperate_id, source_type });
				} else {
					this.product_url = product_url;
				}
			} finally {
				this.loading = false;
			}
		},
		async getSkuList() {
			const sku_list = await getProductSkuListOne({ productId: this.product_id, platformId: this.platformId });
			this.spec = sku_list && sku_list.length ? sku_list.map(item => item.specification).join('、') : this.spec;
		},
		async asyncSkuList() {
			// 同步商品sku， 抖音更改了同步sku的限额，所以只能按需同步，使用哪个商品就调用同步哪个sku

			await syncProductSkuList({
				platformId: this.platformId,
				productIds: [
					{
						outProductId: this.third_product_id,
						productId: this.product_id,
					},
				],
				source: dataMap.syncSkuSource.share,
			});
		},
		handleClose() {
			this.recommendInfoChecked = false;
			this.shopScoreChecked = false;
			this.drawer = false;
		},
		async copy(value) {
			let res = await clipboard(this.$refs[value]);
			if (res) {
				this.$message.success('复制成功');
			} else {
				this.$message.error('复制失败');
			}
		},
		async copyAll() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: 'content',
				[dataMap.PLATFORM_KS.value]: 'content',
				[dataMap.PLATFORM_SP.value]: 'content',
				[dataMap.PLATFORM_XHS.value]: 'content',
			};
			let res = await clipboard(this.$refs[temPF[this.platformId]]);
			if (res) {
				this.$message.success('复制成功');
			} else {
				this.$message.error('复制失败');
			}
		},
		async dyInit({ product_id, cooperate_id, source_type }) {
			const { code, data } = await getSourceUrl({ product_id, cooperate_id });
			if (code === 0) {
				this.product_url = data.pick_source;
				if (source_type === '1') {
					this.content = '该链接非团长商品链接，达人使用该链接(托管商品链接除外)带货产生的订单无法统计到团队业绩。';
					this.state = '2';
				} else {
					this.content = '已生成专属链接，达人可直接通过该链接带货并统计为你的业绩';
					this.state = '1';
				}
			} else {
				this.content = '非专属链接，可能无法统计到你的业绩';
				this.state = '2';
			}
		},
	},
};
</script>
<style lang="less" scoped>
.drawer-box {
	position: relative;
	padding: 16px 24px !important;
}
.tips {
	padding: 11px 16px;
	border-radius: 2px;
}
.defalut {
	background: rgba(36, 117, 255, 0.1);
	border: 1px solid hsla(218, 100%, 57%, 0.3);
}
.warning {
	background: #fef3e7;
	border: 1px solid @color-warning;
}
.warn {
	color: @color-warning;
}
.primary {
	color: @color-primary;
}
.footer {
	width: 100%;
	position: absolute;
	right: 0;
	bottom: 0;
	display: flex;
	justify-content: flex-end;
	padding: 16px 24px;
	border-top: 1px solid #eeeeee;
	background-color: #fff;
}
.content {
	padding: 32px 20px;
	background-color: #f5f5f5;
	margin-bottom: 70px;
}
.top-img {
	width: 140px;
	height: 140px;
	border-radius: 8px;

	img {
		width: 140px;
		height: 140px;
	}
	.defalut-img {
		width: 140px;
		height: 140px;
		position: relative;
		.img-loading {
			position: absolute;
			top: 40%;
			left: 45%;
			font-size: 22px;
		}
		.default-icon {
			font-size: 140px;
			color: #fff;
		}
	}
}
.avatar {
	width: 38px;
	height: 38px;
}
.chat {
	background-color: #94ec69;
}
.info {
	background-color: #fff;
}
.chat,
.info {
	width: 180px;
	padding: 12px 16px;
	border-radius: 8px;
	position: relative;
}
.chat::before,
.info::before {
	width: 0;
	height: 0;
	overflow: hidden;
	border: 5px solid transparent;
	content: '';
	display: block;
	right: 100%;
	position: absolute;
	top: 15px;
}
.chat::before {
	border-right-color: #94ec69;
}
.info::before {
	border-right-color: #fff;
}
.top-img,
.chat-box,
.info-box {
	display: flex;
	align-items: flex-end;
}
.copy-box {
	padding: 6px;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px;
	color: #fff;
	cursor: pointer;
	margin-left: 8px;
}
</style>
